// Money formatting function
window.formatMoney = function (cents, format) {
    if (typeof cents == 'string') {
        cents = cents.replace('.', '')
    }
    var value = ''
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
    var formatString = format || this.money_format

    function defaultOption(opt, def) {
        return typeof opt == 'undefined' ? def : opt
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2)
        thousands = defaultOption(thousands, ',')
        decimal = defaultOption(decimal, '.')

        if (isNaN(number) || number == null) {
            return 0
        }

        number = (number / 100.0).toFixed(precision)

        var parts = number.split('.')
        var dollarsAmount = parts[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            '$1' + thousands
        )
        var centsAmount = parts[1] ? decimal + parts[1] : ''

        // Remove trailing zeros from cents
        if (centsAmount && centsAmount !== decimal + '00') {
            // Only show cents if they're not .00
            return dollarsAmount + centsAmount
        } else {
            // Don't show .00
            return dollarsAmount
        }
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2)
            break
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0)
            break
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',')
            break
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',')
            break
    }

    return formatString.replace(placeholderRegex, value)
}
;(function () {
    function cartGlobals() {
        /**
         * Injects HTML in to the slideout cart
         *
         * @param { newCart } object - the cart object
         * @param { openWhenDone } boolean - whether to open the slideout cart when its populated
         */
        window._populateSlideOutCart = async function (newCart, openWhenDone) {
            let templateItemHTML =
                document.querySelector('#cart-template').innerHTML
            let sidebarContent = document.querySelector(
                '#cart-slideout-contents'
            )
            let subtotalEl = document.querySelector('#cart-slideout-subtotal')
            let outputHTML = ''

            const promises = newCart.items.map(async function (item, index) {
                let temporaryHTML = templateItemHTML

                temporaryHTML = temporaryHTML.replaceAll('#URL#', item.url)
                temporaryHTML = temporaryHTML.replaceAll(
                    '#HANDLE#',
                    item.handle
                )
                temporaryHTML = temporaryHTML.replaceAll(
                    '#TITLE#',
                    item.product_title.replace('®', '<sup>®</sup>')
                )
                temporaryHTML = temporaryHTML.replaceAll(
                    '#FINALPRICE#',
                    window.formatMoney(
                        item.final_line_price,
                        window.money_format
                    )
                )
                temporaryHTML = temporaryHTML.replaceAll('#ID#', item.id)
                temporaryHTML = temporaryHTML.replaceAll('#QTY#', item.quantity)
                temporaryHTML = temporaryHTML.replaceAll('#INDEX#', index + 1)
                temporaryHTML = temporaryHTML.replaceAll('#IMG#', item.image)

                let metaData = await _ajaxGetVariantStock(item.handle)
                let variantStock = metaData.variantStock

                if (variantStock && variantStock[item.id]) {
                    temporaryHTML = temporaryHTML.replaceAll(
                        '#STOCK#',
                        variantStock[item.id].inventory
                    )

                    // Only show availability notice if stock is low (10 or fewer items)
                    const lowStockThreshold = 10
                    const isLowStock =
                        variantStock[item.id].inventory <= lowStockThreshold

                    if (
                        variantStock[item.id].inventory_policy == 'continue' ||
                        variantStock[item.id].inventory_management == 'null'
                    ) {
                        temporaryHTML = temporaryHTML.replaceAll(
                            '#INVALID#',
                            'invalid'
                        )
                    } else {
                        temporaryHTML = temporaryHTML.replaceAll(
                            '#INVALID#',
                            ''
                        )
                    }

                    if (item.quantity < variantStock[item.id].inventory) {
                        temporaryHTML = temporaryHTML.replaceAll(
                            '#DISABLED#',
                            isLowStock ? 'disabled' : 'hidden'
                        )
                    } else {
                        temporaryHTML = temporaryHTML.replaceAll(
                            '#DISABLED#',
                            'hidden'
                        )
                    }
                } else {
                    // No inventory data available, hide the notice
                    temporaryHTML = temporaryHTML.replaceAll(
                        '#DISABLED#',
                        'hidden'
                    )
                    temporaryHTML = temporaryHTML.replaceAll('#INVALID#', '')
                }

                // Handle discount display
                let discountBadge = ''
                let originalPrice = ''

                if (item.final_line_price < item.original_total_price) {
                    // Calculate discount percentage
                    const discountAmount =
                        item.original_total_price - item.final_line_price
                    const discountPercentage = Math.round(
                        (discountAmount / item.original_total_price) * 100
                    )

                    discountBadge = `<span class="inline-block px-2 py-1 mr-2 text-xs font-bold text-white bg-red-500 rounded-md">-${discountPercentage}%</span>`
                    originalPrice = `<s class="ml-2 text-sm text-gray-500">${window.formatMoney(item.original_line_price, window.money_format)}</s>`
                }

                temporaryHTML = temporaryHTML.replaceAll(
                    '#DISCOUNT_BADGE#',
                    discountBadge
                )
                temporaryHTML = temporaryHTML.replaceAll(
                    '#ORIGINAL#',
                    originalPrice
                )

                let optionsHTML = ''

                if (item.selling_plan_allocation) {
                    temporaryHTML = temporaryHTML.replaceAll(
                        '#SUBSCRIPTION#',
                        '<p>' +
                            item.selling_plan_allocation.selling_plan.name +
                            '</p>'
                    )
                } else {
                    temporaryHTML = temporaryHTML.replaceAll(
                        '#SUBSCRIPTION#',
                        ''
                    )
                }

                if (!item.product_has_only_default_variant) {
                    item.options_with_values.forEach((variant) => {
                        optionsHTML += '<span class="text-sm variant-title">'
                        optionsHTML +=
                            variant.name + ': <b>' + variant.value + '</b> '
                        optionsHTML += '</span>'
                    })
                }

                temporaryHTML = temporaryHTML.replace('#OPTIONS#', optionsHTML)

                if (enable_minmax_buys) {
                    let metafields = await _ajaxGetMetafields(item.handle)

                    if (
                        metafields &&
                        metafields.min_buy &&
                        metafields.max_buy
                    ) {
                        temporaryHTML = temporaryHTML.replaceAll(
                            '#MIN#',
                            metafields.min_buy
                        )
                        temporaryHTML = temporaryHTML.replaceAll(
                            '#MAX#',
                            metafields.max_buy
                        )
                    }
                } else {
                    temporaryHTML = temporaryHTML.replaceAll('#MIN#', 1)
                    temporaryHTML = temporaryHTML.replaceAll('#MAX#', 999999)
                }

                outputHTML += temporaryHTML

                // remove upsell if this is the product being upsold
                if (
                    document.querySelector(
                        '.cart-upsell__product[data-id="' + item.id + '"]'
                    )
                ) {
                    _removeUpsellItem(item.id)
                }

                _updateFreeShippingElement(newCart)

                return temporaryHTML
            })

            // Wait for all promises to resolve
            const outputHTMLArray = await Promise.all(promises)

            // Concatenate all HTML strings in the array into a single string
            sidebarContent.innerHTML = outputHTMLArray.join('')
            subtotalEl.textContent = window.formatMoney(
                newCart.total_price,
                window.money_format
            )

            if (openWhenDone) {
                document.body.classList.add('cart-open')

                // Show overlay when cart opens
                const overlay = document.querySelector('.main-overlay')
                if (overlay) {
                    overlay.classList.remove('opacity-0')
                    overlay.style.pointerEvents = 'auto'
                }
            }
        }

        /**
         * Update the slide out cart via ajax, just when clicking the qty buttons & deleting items
         *
         * @param { el } object
         * @param { callback } function
         */
        window._ajaxUpdateCart = function (el, callback = false) {
            let closestForm = el.closest('form')
            let formData = new FormData(closestForm)
            let queryString = new URLSearchParams(formData).toString()
            let updateURL =
                window.Shopify.routes.root + 'cart/update.js?' + queryString

            fetch(updateURL, {
                method: 'POST',
            })
                .then((response) => {
                    if (response.ok) {
                        return response.json()
                    } else {
                        return Promise.reject(
                            'Error: Network response was not ok.'
                        )
                    }
                })
                .then((data) => {
                    // update slideout cart visible values
                    let slideOutTotal = document.querySelector(
                        '#cart-slideout-subtotal'
                    )

                    if (data.total_price && slideOutTotal) {
                        slideOutTotal.textContent = window.formatMoney(
                            data.total_price,
                            window.money_format
                        )

                        // Always update the original price element when cart changes
                        let slideOutOriginal = document.querySelector(
                            '#cart-slideout-original'
                        )
                        if (slideOutOriginal) {
                            if (
                                data.original_total_price &&
                                data.original_total_price > data.total_price
                            ) {
                                slideOutOriginal.textContent =
                                    window.formatMoney(
                                        data.original_total_price,
                                        window.money_format
                                    )
                                slideOutOriginal.style.display = 'inline'
                            } else {
                                // Hide the original price if no discount
                                slideOutOriginal.style.display = 'none'
                            }
                        }

                        let slideOutDiscount = document.querySelector(
                            '#cart-slideout-discount'
                        )

                        if (slideOutDiscount && data.total_discount > 0) {
                            slideOutDiscount.textContent =
                                '-' +
                                window.formatMoney(
                                    data.total_discount,
                                    window.money_format
                                )
                        } else if (slideOutDiscount) {
                            slideOutDiscount.textContent = ''
                        }
                    }

                    if (data.items) {
                        data.items.forEach((item, index) => {
                            let thisCartEl = closestForm.querySelector(
                                '[data-id="' + item.id + '"]'
                            )

                            if (thisCartEl) {
                                let thisSubtotalEl =
                                    thisCartEl.querySelector('[data-subtotal]')

                                if (thisSubtotalEl) {
                                    thisSubtotalEl.textContent =
                                        window.formatMoney(
                                            item.line_price,
                                            window.money_format
                                        )
                                }
                            }
                        })
                    }

                    _updateFreeShippingElement(data)

                    if (callback !== false) {
                        callback()
                    }
                })
                .catch((error) => console.error(error))
        }

        /**
         *
         * Based on the min/max quantities, this checks if the user is allowed to add that many to their cart
         *
         */
        window._canUpdateCart = async function (formData) {
            let metafields = await _ajaxGetMetafields(formData.get('handle'))

            let cartData = await _getCart()

            let maxLimitReached = false
            let minLimitReached = false
            let amended = false
            let found = false
            let tryingToAdd = formData.get('quantity')

            cartData.items.forEach((item) => {
                // cartData/item = the cart/item state right now
                // tryingToAdd = the quantity we're trying to add
                // if the quantity we're trying to add, plus whatever is already in the cart, is more than the max, amend the qty in the cart to the max
                // if the quantity we're trying to add, plus whatever is already in the cart, is less than the min, amend the qty in the cart to the min
                if (item.id == formData.get('id')) {
                    found = true

                    if (
                        !formData.get('direction') ||
                        formData.get('direction') == 'increment'
                    ) {
                        if (
                            parseInt(tryingToAdd) + parseInt(item.quantity) >
                            metafields.max_buy
                        ) {
                            _doMaxLimit()
                        }
                    }

                    if (
                        !formData.get('direction') ||
                        formData.get('direction') == 'decrement'
                    ) {
                        if (
                            parseInt(tryingToAdd) + parseInt(item.quantity) <
                            metafields.min_buy
                        ) {
                            _doMinLimit()
                        }
                    }
                }
            })

            // must be adding a new one
            if (!found) {
                if (
                    !formData.get('direction') ||
                    formData.get('direction') == 'increment'
                ) {
                    if (parseInt(tryingToAdd) > metafields.max_buy) {
                        _doMaxLimit()
                    }
                }
                if (
                    !formData.get('direction') ||
                    formData.get('direction') == 'decrement'
                ) {
                    if (parseInt(tryingToAdd) < metafields.min_buy) {
                        _doMinLimit()
                    }
                }
            }

            /**
             *
             * Runs if they hit the minimum limit
             *
             */
            function _doMinLimit() {
                // this line updates the cart to be the minimum
                amended = metafields.min_buy

                minLimitReached = true

                // replace this alert with a modal or anything you like
                _toastAlert(`
				<p>This product has a minimum purchase quantity of ${metafields.min_buy}.</p>
				<p>Your cart has been updated.</p>
			`)
            }

            /**
             *
             * Runs if they hit the maximum limit
             *
             */
            function _doMaxLimit() {
                // this line updates the cart to be the maximum
                amended = metafields.max_buy

                maxLimitReached = true

                // replace this alert with a modal or anything you like
                _toastAlert(`
				<p>This product has a maximum quantity limit of ${metafields.max_buy}.</p>
				<p>Your cart has been updated.
			`)
            }

            return {
                maxLimit: maxLimitReached,
                minLimit: minLimitReached,
                amended: amended,
                max: metafields.max_buy,
                min: metafields.min_buy,
            }
        }

        /**
         *
         * Updates cart count elements throughout the page
         *
         */
        function _updateCartCountElements(cart) {
            // Update all cart count elements
            const cartCountElements = document.querySelectorAll(
                '.cart-icon span, [data-cartcount], .cart-count, .cart-badge'
            )

            cartCountElements.forEach((element) => {
                element.textContent = cart.item_count
            })

            // Update cart count in navigation/header
            const headerCartCount = document.querySelector(
                '.header .cart-count, .nav .cart-count'
            )
            if (headerCartCount) {
                headerCartCount.textContent = cart.item_count
            }

            // Hide cart count if cart is empty
            const cartCountBadges = document.querySelectorAll(
                '.cart-badge, .cart-count'
            )
            cartCountBadges.forEach((badge) => {
                if (cart.item_count === 0) {
                    badge.style.display = 'none'
                } else {
                    badge.style.display = 'block'
                }
            })
        }

        /**
         *
         * For Ajax cart support, this retrieves the contents of the cart and updates values on the page
         * It also fires the klaviyo tracking script
         *
         */
        window._updateCartTotals = async function (product, adding = true) {
            let newCart = await _getCart()

            // Update cart count elements throughout the page
            _updateCartCountElements(newCart)

            // Update main cart page elements if we're on the cart page
            if (window.location.pathname === '/cart') {
                // Update cart subtotal
                const cartSubtotal = document.querySelector(
                    '.section-cart .sub-total__text strong'
                )
                if (cartSubtotal) {
                    cartSubtotal.textContent = window.formatMoney(
                        newCart.total_price,
                        window.money_format
                    )
                }

                // Update cart discount if it exists
                if (newCart.total_discount > 0) {
                    const cartDiscount = document.querySelector(
                        '.section-cart .discount'
                    )
                    if (cartDiscount) {
                        cartDiscount.textContent =
                            '- ' +
                            window.formatMoney(
                                newCart.total_discount,
                                window.money_format
                            )
                    }
                } else {
                    // Hide discount row if no discount
                    const discountRow = document.querySelector(
                        '.section-cart tr:has(.discount)'
                    )
                    if (discountRow) {
                        discountRow.style.display = 'none'
                    }
                }

                // Update free shipping elements
                _updateFreeShippingElement(newCart)

                // If cart is empty, show empty cart message
                if (newCart.item_count === 0) {
                    const cartForm =
                        document.querySelector('.section-cart form')
                    if (cartForm) {
                        cartForm.innerHTML =
                            '<p class="text-center">Your cart is empty.</p>'
                    }
                }
            }

            // Update slideout cart if enabled and not on main cart page
            if (
                window.enable_slide_cart &&
                window.location.pathname !== '/cart'
            ) {
                _populateSlideOutCart(newCart, true)
            }

            // Track Klaviyo event only when adding products
            if (adding && product) {
                _trackKlaviyoAddToCart(newCart, product)
            }

            // Dispatch cart:updated event for upsells and other components
            document.dispatchEvent(
                new CustomEvent('cart:updated', {
                    detail: { cart: newCart, product: product, adding: adding },
                })
            )

            // Also trigger upsell population directly
            if (typeof window.populateUpsellTemplate === 'function') {
                window.populateUpsellTemplate()
            }
        }

        /**
         *
         * This adds a product to the cart via ajax
         *
         */
        window._ajaxAddToCart = function (formData, callback) {
            let queryString = new URLSearchParams(formData).toString()
            let updateURL =
                window.Shopify.routes.root + 'cart/add.js?' + queryString

            if (formData.get('updating')) {
                queryString =
                    'updates[' +
                    formData.get('id') +
                    ']=' +
                    formData.get('quantity')
                updateURL =
                    window.Shopify.routes.root + 'cart/update.js?' + queryString
            }

            fetch(updateURL, {
                method: 'POST',
            })
                .then((response) =>
                    response.ok
                        ? response.json()
                        : Promise.reject('Error: Network response was not ok.')
                )
                .then((data) => {
                    callback(data)
                })
                .catch((error) => {
                    // console.log('Error: ' + error)
                    callback(false)
                })
        }

        /**
         *
         * Just gets the cart and triggers a callback
         *
         */
        window._getCart = async function () {
            let cartURL = window.Shopify.routes.root + 'cart.js?'

            try {
                const response = await fetch(cartURL)
                const data = await response.text()

                return JSON.parse(data)
            } catch (error) {
                console.error('Error fetching page:', error)
                throw error
            }
        }

        /**
         *
         * Checks the input quantities on the cart page
         *
         */
        window._checkCartPageQuantities = async function (mins, maxs) {
            let cart = await _getCart()

            if (cart.items) {
                cart.items.forEach((cartItem) => {
                    if (mins[cartItem.id]) {
                        if (cartItem.quantity < mins[cartItem.id]) {
                            _thisUpdateQty(
                                cartItem.id,
                                mins[cartItem.id],
                                cartItem.title
                            )
                        }
                    }
                })
                cart.items.forEach((cartItem) => {
                    if (maxs[cartItem.id]) {
                        if (cartItem.quantity > maxs[cartItem.id]) {
                            _thisUpdateQty(
                                cartItem.id,
                                maxs[cartItem.id],
                                cartItem.title
                            )
                        }
                    }
                })
            }

            function _thisUpdateQty(id, qty, title) {
                let thisQtyInput = document.querySelector(
                    '.section-cart [data-id="' + id + '"] [name="updates[]"]'
                )
                let thisFormUpdate = thisQtyInput
                    .closest('form')
                    .querySelector('[name="update"]')

                if (thisQtyInput) {
                    thisQtyInput.value = qty
                }

                sessionStorage.setItem(
                    'toastOnLoad',
                    '<p>Updated quantity of product:<br/> <span>' +
                        title +
                        '</span> <br/>as it exceeded the allowed limit per customer.</p>'
                )

                thisFormUpdate.click()
            }
        }

        /**
         *
         * Klaviyo abandoned cart tracking
         * https://help.klaviyo.com/hc/en-us/articles/115001396711
         *
         */
        window._trackKlaviyoAddToCart = function (cartData, product) {
            if (!product || (!product.id && !product.ProductID)) {
                return
            }

            let allCartData = {},
                itemCart = {}

            // get what we can from the product obj,  ifs not there already
            if (!product.ProductID) {
                itemCart = {
                    Brand: product.vendor,
                    Categories: product.type,
                    ImageURL: product.image,
                    Name: product.product_title,
                    Price: window.formatMoney(
                        product.price,
                        window.money_format
                    ),
                    CompareAtPrice: window.formatMoney(
                        product.compare_at_price,
                        window.money_format
                    ),
                    ProductID: product.id,
                    URL:
                        window.location.origin +
                        '/products/' +
                        product.handle +
                        '/',
                }
            } else {
                itemCart = product
            }

            if (cartData) {
                allCartData = {
                    total_price: cartData.total_price / 100,
                    $value: cartData.total_price / 100,
                    total_discount: cartData.total_discount,
                    original_total_price: cartData.original_total_price / 100,
                    items: cartData.items,
                }
            }

            allCartData = Object.assign(allCartData, itemCart)

            _learnq.push(['track', 'Added to Cart', allCartData])
        }

        /**
         *
         * This queries a template called product.metafields.liquid
         * You need to set this template up to return whatever json you want to query
         * In this function this is used for the min/max buys to query the quantity limits with ajax
         *
         */
        window._ajaxGetMetafields = async function (productHandle) {
            let thisURL =
                window.Shopify.routes.root +
                'products/' +
                productHandle +
                '/?view=metafields'

            try {
                const response = await fetch(thisURL)
                const data = await response.json()
                return data.metafields
            } catch (error) {
                console.error('Error fetching page:', error)
                throw error
            }
        }

        /**
         *
         * This queries a template called product.metafields.liquid
         * You need to set this template up to return whatever json you want to query
         * In this function this is used to query the variant Stock ajax
         *
         */
        window._ajaxGetVariantStock = async function (productHandle) {
            let thisURL =
                window.Shopify.routes.root +
                'products/' +
                productHandle +
                '/?view=metafields'

            try {
                const response = await fetch(thisURL)
                const data = await response.json()
                return data
            } catch (error) {
                console.error('Error fetching page:', error)
                throw error
            }
        }

        /**
         *
         * Creates a FormData object from a standard js object
         *
         */
        window._createFormDataFromObject = function (obj) {
            const formData = new FormData()

            for (const key in obj) {
                if (obj.hasOwnProperty(key)) {
                    formData.append(key, obj[key])
                }
            }

            return formData
        }

        /**
         *
         * Updates the free shipping element values when the cart changes
         *
         */
        function _updateFreeShippingElement(cart) {
            let freeShippingContainers =
                document.querySelectorAll('.free-shipping')

            if (freeShippingContainers.length) {
                freeShippingContainers.forEach((el) => {
                    let thisThreshold = el.dataset.threshold
                    let amountLeftSpan = el.querySelector('[data-amount-left]')
                    let progressWidthSpan = el.querySelector(
                        '.free-shipping__progress span'
                    )

                    // Handle empty cart
                    if (!cart || cart.total_price === 0) {
                        if (progressWidthSpan) {
                            progressWidthSpan.style.width = '0%'
                        }
                        if (amountLeftSpan) {
                            amountLeftSpan.textContent = window.formatMoney(
                                thisThreshold,
                                window.money_format
                            )
                        }
                        el.classList.add('remaining')
                        return
                    }

                    // Calculate progress percentage
                    const progressPercentage = Math.min(
                        (cart.total_price / thisThreshold) * 100,
                        100
                    )

                    if (progressWidthSpan) {
                        progressWidthSpan.style.width = progressPercentage + '%'
                    }

                    if (cart.total_price >= thisThreshold) {
                        el.classList.remove('remaining')
                        if (amountLeftSpan) {
                            amountLeftSpan.textContent =
                                'Free shipping unlocked!'
                        }
                    } else {
                        if (amountLeftSpan) {
                            amountLeftSpan.textContent = window.formatMoney(
                                thisThreshold - cart.total_price,
                                window.money_format
                            )
                        }
                        el.classList.add('remaining')
                    }
                })
            }
        }
    }

    function cartSlide() {
        // Get cart open triggers (exclude close buttons)
        let cartOpenTriggers = document.querySelectorAll(
            '[data-cartslide]:not(.cart-slideout__close)'
        )
        let cartOverlay = document.querySelector('.cart-overlay')

        // Handle cart open triggers
        cartOpenTriggers.forEach((item) => {
            item.addEventListener('click', function (e) {
                e.preventDefault()
                const isCartOpen = document.body.classList.contains('cart-open')

                if (!isCartOpen) {
                    document.body.classList.add('cart-open')
                    console.log('Cart opening, removing opacity-0 from overlay')

                    // Show overlay by removing opacity-0 class
                    const overlay = document.querySelector('.main-overlay')
                    if (overlay) {
                        console.log('Overlay found, removing opacity-0 class')
                        overlay.classList.remove('opacity-0')
                        overlay.style.pointerEvents = 'auto'
                        console.log(
                            'Opacity-0 removed, classes now:',
                            overlay.className
                        )
                    } else {
                        console.log('Overlay not found')
                    }
                } else {
                    // If cart is already open, close it
                    document.body.classList.remove('cart-open')

                    // Hide overlay by adding opacity-0 class
                    const overlay = document.querySelector('.main-overlay')
                    if (overlay) {
                        overlay.classList.add('opacity-0')
                        overlay.style.pointerEvents = 'none'
                    }
                }
            })
        })

        // Close cart when clicking the close button (specific selector for close button only)
        const cartCloseButtons = document.querySelectorAll(
            '.cart-slideout__close[data-cartslide]'
        )
        cartCloseButtons.forEach((button) => {
            button.addEventListener('click', function (e) {
                e.preventDefault()
                document.body.classList.remove('cart-open')

                // Hide overlay by adding opacity-0 class
                const overlay = document.querySelector('.main-overlay')
                if (overlay) {
                    overlay.classList.add('opacity-0')
                    overlay.style.pointerEvents = 'none'
                }
            })
        })

        // this is a variable set within the cart-slideout.liquid file
        if (typeof customCart !== 'undefined') {
            _populateSlideOutCart(customCart, false)
        }

        /**
         *
         * Handle the remove button in the ajax cart
         *
         */
        _removeButton()

        function _removeButton() {
            // Handle remove buttons for both slideout cart and main cart
            document.addEventListener('click', function (e) {
                // Check if the clicked element or its parent has the remove-item class
                let removeButton = e.target.closest('.remove-item')

                if (removeButton) {
                    e.preventDefault()
                    console.log('Remove button clicked:', removeButton)

                    let thisItem = removeButton.closest('.cart-item')
                    if (!thisItem) {
                        console.error('Could not find cart item container')
                        return
                    }

                    let thisQtyInput = thisItem.querySelector('[type="number"]')
                    if (!thisQtyInput) {
                        console.error('Could not find quantity input')
                        return
                    }

                    console.log(
                        'Setting quantity to 0 for item:',
                        thisItem.dataset.id
                    )
                    thisQtyInput.value = 0

                    // Find the appropriate form (slideout or main cart)
                    let form =
                        thisItem
                            .closest('.cart-slideout')
                            ?.querySelector('form') ||
                        thisItem.closest('.section-cart')?.querySelector('form')

                    if (!form) {
                        console.error('Could not find cart form')
                        return
                    }

                    console.log('Updating cart via AJAX')
                    _ajaxUpdateCart(form, function (response) {
                        console.log('Cart updated successfully:', response)
                        // Update cart totals without tracking (since we're removing, not adding)
                        _updateCartTotals(null, false)
                        // Always repopulate the slideout cart to ensure all elements are in sync
                        if (
                            window.enable_slide_cart &&
                            window.location.pathname !== '/cart'
                        ) {
                            _getCart().then(function (newCart) {
                                _populateSlideOutCart(newCart, false)
                            })
                        }
                    })

                    // Remove the item from DOM
                    thisItem.remove()
                    console.log('Item removed from DOM')
                }
            })
        }

        /**
         *
         * Handle the upsells in the slideout cart
         *
         */
        _upsells()

        function _upsells() {
            let slideOutCart = document.querySelector('.cart-slideout')
            if (!slideOutCart) {
                return
            }

            slideOutCart.addEventListener('click', function (e) {
                if (e.target.dataset.upsell) {
                    e.preventDefault()

                    let upsellElement = e.target.closest('.cart-upsell')

                    let formObject = {
                        id: e.target.dataset.upsell,
                        quantity: 1,
                    }

                    let thisFormData = _createFormDataFromObject(formObject)

                    e.target.textContent = 'Adding...'

                    _ajaxAddToCart(thisFormData, function (response) {
                        if (response.id) {
                            _updateCartTotals(response)
                            _removeUpsellItem(e.target.dataset.upsell)
                        } else {
                            e.target.textContent = 'Unable To Add'
                        }
                    })
                }
            })
        }

        // refresh the slider in the upsell module, when a slide is removed
        function _removeUpsellItem(id) {
            let foundProducts = document.querySelectorAll(
                '.cart-upsell__product[data-id="' + id + '"]'
            )

            foundProducts.forEach(function (el, index) {
                el.parentNode.remove()
            })

            // remove upsells if none left
            if (!foundProducts.length) {
                let foundSliders = document.querySelectorAll('.upsell-slider')
                foundSliders.forEach(function (item, index) {
                    item.remove()
                })

                return
            }

            let allUpsellEls = document.querySelectorAll(
                '[id*="upsell-slider"]'
            )

            for (const key in window.sliders) {
                if (window.sliders.hasOwnProperty(key)) {
                    const slider = window.sliders[key]
                    slider.update()
                }
            }
        }
    }

    function addToCart() {
        let addToCartForms = document.querySelectorAll(
            'form[action="/cart/add"]:not(.disable-ajax)'
        )
        let atcProcessing = false
        let runningTimeout
        let atcPopup = document.querySelector('.atc-popup')

        if (!addToCartForms.length) {
            return
        }

        if (window.enable_ajax_cart) {
            document.addEventListener('submit', async function (e) {
                let el = e.target

                if (
                    el.getAttribute('action') == '/cart/add' &&
                    !el.classList.contains('.disable-ajax')
                ) {
                    e.preventDefault()
                } else {
                    return true
                }

                if (atcProcessing) {
                    return false
                }

                let atcBtn = el.querySelector('[type="submit"]')

                if (atcBtn) {
                    atcBtn.textContent = 'Adding...'
                }

                atcProcessing = true

                let formData = new FormData(el)

                /**
                 *
                 * If min max buy limits are active, check if this can actually be added
                 *
                 */
                if (window.enable_minmax_buys) {
                    let canUpdate = await _canUpdateCart(formData)

                    if (canUpdate.amended) {
                        formData.set('quantity', canUpdate.amended)
                        formData.set('updating', true)
                    }

                    if (canUpdate.maxLimit) {
                        atcBtn.textContent = 'Limit Reached'
                    }
                }

                _ajaxAddToCart(formData, function (response) {
                    if (response.id || response.item_count) {
                        atcBtn.textContent = 'Added To Cart'
                        atcProcessing = false

                        _updateCartTotals(response)

                        // in case this is open
                        if (document.querySelector('#quickViewModal.is-open')) {
                            const modal =
                                document.querySelector('#quickViewModal')
                            if (modal && typeof _closeModal === 'function') {
                                _closeModal(modal)
                            } else {
                                // Fallback: manually hide the modal
                                modal.style.display = 'none'
                                modal.style.opacity = '0'
                                modal.style.pointerEvents = 'none'
                                modal.classList.remove('is-open')
                                document.body.classList.remove('modal-open')
                            }
                        }

                        if (!window.enable_slide_cart) {
                            _toastAlert(`
							<p>Item Added To Cart</p>
							<a class="btn" href="/cart">
								View Cart
							</a>
						`)
                        }
                    } else {
                        if (atcBtn) {
                            atcBtn.textContent =
                                'Error Adding, Please Check Your Cart'
                        }
                    }
                })
            })
        } else {
            // non ajax klaviyo tracking
            addToCartForms.forEach(function (el, index) {
                el.addEventListener('submit', function (e) {
                    e.preventDefault()
                    let isQV = el.closest('#quickViewModal')

                    if (isQV) {
                        _trackKlaviyoAddToCart(false, window.qvItem)
                    } else if (typeof window.item !== 'undefined') {
                        _trackKlaviyoAddToCart(false, window.item)
                    }

                    // 100ms timeout so klaviyo can send its event off
                    setTimeout(function () {
                        el.submit()
                    }, 100)
                })
            })
        }
    }

    cartGlobals()

    window.addEventListener('load', function () {
        cartSlide()
        addToCart()
    })
})()
